"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllNestedTags = getAllNestedTags;
function getAllNestedTags(tags) {
    const result = [];
    function traverse(tagList) {
        for (const tag of tagList) {
            result.push(tag);
            if (tag.childrens && tag.childrens.length > 0) {
                traverse(tag.childrens);
            }
        }
    }
    traverse(tags);
    return result;
}
